import { MAJOR_ARCANA } from "./major-arcana";
import { MINOR_CUPS } from "./minor-cups";
import { MINOR_PENTACLES } from "./minor-pentacles";
import { MINOR_SWORDS } from "./minor-swords";
import { MINOR_WANDS } from "./minor-wands";

export * from "./major-arcana";
export * from "./minor-pentacles";
export * from "./minor-cups";
export * from "./minor-swords";
export * from "./minor-wands";

export const FULL_DECK = [
  ...MAJOR_ARCANA,
  ...MINOR_PENTACLES,
  ...MINOR_CUPS,
  ...MINOR_SWORDS,
  ...MINOR_WANDS,
];
